
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.338","height":"12.762"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"グループ 54","fill":"#0ac"}},[_c('path',{attrs:{"data-name":"パス 167","d":"M11.543 5.79H5.957c-.439 0-.794.265-.794.591s.356.591.794.591h5.586c.439 0 .794-.265.794-.591s-.356-.591-.794-.591z"}}),_c('path',{attrs:{"data-name":"パス 168","d":"M11.746 10.896H8.025v-.092a.591.591 0 10-1.182 0v1.367a.591.591 0 001.182 0v-.092h3.721a.591.591 0 000-1.182z"}}),_c('path',{attrs:{"data-name":"パス 169","d":"M4.803 10.906l-3.793-.02h-.009c-.549 0-1 .261-1 .586s.44.593.992.6l3.793.02h.009c.549 0 1-.261 1-.586s-.439-.597-.992-.6z"}}),_c('path',{attrs:{"data-name":"パス 170","d":"M3.735 5.106a.683.683 0 00-.747.591v.092H.75a.607.607 0 100 1.182h2.241v.092a.768.768 0 001.494 0V5.697a.683.683 0 00-.75-.591z"}}),_c('path',{attrs:{"data-name":"パス 171","d":"M11.587.683H9.336V.591a.772.772 0 00-1.5 0v1.367a.772.772 0 001.5 0v-.094h2.251a.608.608 0 100-1.182z"}}),_c('path',{attrs:{"data-name":"パス 172","d":"M.775 1.865h5.448a.613.613 0 100-1.182H.775a.613.613 0 100 1.182z"}})])])
          )
        }
      }
    